(function($) {

    // insights grid animation
    $('.js-insights-toggle').each(function() {

        // click
        $(this).on('click', function(e) {
            e.preventDefault();
            $this = $(this);
            $this.parent().addClass('is-active');

            var insightURL = $this.attr('href');

            setTimeout(function() {
                location = insightURL;
            }, 1000)
        });

        // mouseover
        $(this).on('mouseover', function() {
            $(this).parent().addClass('is-mouseover');

            if($('.card-insight.is-mouseover').length === 15) {
                $('.insights-grid').addClass('is-completed')
            }
        });

    });

    // adds is-mouseover class to random card item when user scrolls down the page
    function insightsRandomHover() {
        if ($(window).width() >= 992) {
            var insightGrid = $("#insightsGrid");
            var cardItem = insightGrid.find(".card-insight");
            var cardNumber = cardItem.length;
            var random = Math.floor((Math.random() * cardNumber));
            cardItem.eq(random).addClass('is-mouseover');
        }
    }

    // fade in insights text on scroll
    $(window).scroll(function() {
        if ($(window).width() >= 992) {
            insightsGrid = $('#insightsGrid');
            insightsCard = $('.card-insight');

            if ($(this).scrollTop() > 60) {
                insightsGrid.addClass('is-scrolled');
                $('.insights-grid').addClass('is-completed')

                insightsRandomHover();
                setInterval(function () {
                    insightsRandomHover();
                }, 1500);
            } else {
                insightsGrid.removeClass('is-scrolled');
                $('.insights-grid').removeClass('is-completed')
            }
        }
    });

}(jQuery));
